import React, { Suspense } from 'react'
import { Outlet, Route } from 'react-router-dom'

import { MainAppLayout } from '../../common/components/appLayout/MainAppLayout'
import { DevToolsModalWrapper } from '../devTools/DevToolsModalWrapper'
import MicrositeIntlProvider from '../microsite/MicrositeIntlProvider'

const PhoneNumberDirectory = React.lazy(
  () =>
    import(
      /* webpackChunkName: "PhoneNumberDirectory" */ '../../common/components/phoneNumberDirectory/PhoneNumberDirectory'
    ),
)

const CustomerSpecificInstanceRedirectionContainer = React.lazy(
  () =>
    import(
      /* webpackChunkName: "CustomerSpecificInstanceRedirection" */ './components/customerSpecificInstanceRedirection/CustomerSpecificInstanceRedirectionContainer'
    ),
)

const Homepage = React.lazy(
  () =>
    import(
      /* webpackChunkName: "Homepage" */
      /* webpackPrefetch: true */
      './components/Homepage/Homepage'
    ),
)

const MicrositeRouteContainer = (
  <MicrositeIntlProvider>
    <MainAppLayout>
      <Outlet />
      <DevToolsModalWrapper />
    </MainAppLayout>
  </MicrositeIntlProvider>
)

export const MicrositeRoutes = (
  <Route element={MicrositeRouteContainer}>
    <Route
      element={
        <>
          <Outlet />
          <Suspense fallback={null}>
            <CustomerSpecificInstanceRedirectionContainer />
          </Suspense>
        </>
      }
    >
      <Route index element={<Homepage />} />
      <Route path='care-team-phone-numbers' element={<PhoneNumberDirectory />} />
    </Route>
  </Route>
)
